import { HIDE_PROMOCODES_INTERNAL_ID } from 'common/constants';
import { useHideSomeExperiment } from './use-hide-some-experiment';

export function useHidePromoCodes() {
  return useHideSomeExperiment(HIDE_PROMOCODES_INTERNAL_ID);
}
